import React, { useState } from 'react';
import { Form, Input, Icon, Popup, Button } from 'semantic-ui-react';
import { NumericFormat, NumberFormatValues } from 'react-number-format';

type ConstructionLoanValues = {
    loanName?: string | null;
    amount?: number | null;
    totalInterestPayments?: number | null;
    hasLoan?: boolean;
};

type Props = {
    values?: ConstructionLoanValues;
    onChange: (values: ConstructionLoanValues) => void;
};

const ConstructionLoan: React.FC<Props> = ({ values = {}, onChange }) => {
    const [formValues, setFormValues] = useState<ConstructionLoanValues>({
        loanName: values.loanName ?? '',
        amount: values.amount ?? null,
        totalInterestPayments: values.totalInterestPayments ?? null,
        hasLoan: values.hasLoan ?? false,
    });

    const addLoan = () => {
        const updatedValues = {
            ...formValues,
            hasLoan: true,
        };
        setFormValues(updatedValues);
        onChange(updatedValues);
    };

    const removeLoan = () => {
        const updatedValues = {
            loanName: '',
            amount: null,
            totalInterestPayments: null,
            hasLoan: false,
        };
        setFormValues(updatedValues);
        onChange(updatedValues);
    };

    const handleChange = (
        name: string,
        value: any
    ) => {
        const updatedValues = {
            ...formValues,
            [name]: name === 'loanName' ? value : Number(value),
        };
        setFormValues(updatedValues);
        onChange(updatedValues);
    };

    const renderLoanFields = () => (
        <div style={{ marginBottom: '24px', padding: '16px', border: '1px solid #e0e0e0', borderRadius: '4px' }}>
            <h3>Construction Loan</h3>

            <Form.Field>
                <label>Construction loan amount</label>
                <NumericFormat
                    thousandSeparator
                    allowNegative={false}
                    customInput={Input}
                    name="amount"
                    value={formValues.amount ?? ''}
                    onValueChange={(values: NumberFormatValues) => handleChange('amount', values.value ? values.value : null)}
                    placeholder="Enter amount..."
                    label={{ basic: true, content: '$' }}
                    labelPosition="right"
                />
            </Form.Field>
            <Form.Field>
                <label>Construction loan total interest payments</label>
                <NumericFormat
                    thousandSeparator
                    allowNegative={false}
                    customInput={Input}
                    name="totalInterestPayments"
                    value={formValues.totalInterestPayments ?? ''}
                    onValueChange={(values: NumberFormatValues) => handleChange('totalInterestPayments', values.value ? values.value : null)}
                    placeholder="Enter amount..."
                    label={{ basic: true, content: '$' }}
                    labelPosition="right"
                    min={0}
                />
            </Form.Field>
            <div style={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #ddd', paddingTop: '16px' }}>
                <Button
                    basic
                    color="red"
                    size="small"
                    onClick={removeLoan}
                    title="Remove construction loan"
                >Remove</Button>
            </div>
        </div>
    );

    return (
        <Form>
            <h4>Construction Loan</h4>

            {formValues.hasLoan ? (
                renderLoanFields()
            ) : (
                <Button
                    secondary
                    type="button"
                    icon="plus"
                    content="Add construction loan"
                    fluid
                    onClick={addLoan}
                    style={{ marginBottom: '24px', padding: '16px', textAlign: 'center', boxShadow: 'none' }}
                />
            )}
        </Form>
    );
};

export default ConstructionLoan;
